// extracted by mini-css-extract-plugin
export default {"wrap":"LoadingPage_wrap__Qr5es","wrapLoaded":"LoadingPage_wrapLoaded__JPxvv","loadingSpinner":"LoadingPage_loadingSpinner__NoIvh","text":"LoadingPage_text__eqcEo"};